

























import Vue from "vue";
import ParticipantNoContentInfoCard from "@/components/participant/participant-no-content-info-card.vue";
import config from "@/config";
import ParticipantMonitorNewCard from "@/components/participant/participant-monitor-new-card.vue";

export default Vue.extend({
  name: "ParticipantMonitores",
  components: {
    ParticipantNoContentInfoCard,
    ParticipantMonitorNewCard,
  },
  computed: {
    monitors: {
      get(): string {
        return this.$store.getters["monitorData/monitorInfo"];
      },
    },
  },
  data() {
    return {
      updateMonitorMethod: 0,
      monitorInfo: config.monitorInfo,
    };
  },
  created() {
    this.retrieveMonitorData(true);
    // Currently this is 10 minutes (in milliseconds)
    this.updateMonitorMethod = setInterval(this.retrieveMonitorData, 300000);
  },
  beforeDestroy() {
    clearInterval(this.updateMonitorMethod);
  },
  methods: {
    async retrieveMonitorData(initial = false) {
      if (initial) {
        this.$store.commit("updateState", { loading_overlay: true });
      }
      await this.$store.dispatch("monitorData/getMonitorInfo");
      if (initial) {
        this.$store.commit("updateState", { loading_overlay: false });
      }
    },
  },
});
